import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withLayout } from '@casanova/casanova-common';
import DailyRentContracts from './DayliRentContracts';

export { default as CloseContract } from './CloseContract';

export default withLayout(compose(connect())(DailyRentContracts));
